/* eslint-disable max-len */
/* 
Stress / Pressure / Fatigue
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 

Distraction / Complacency / Lack of awareness
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},

Lack of communication / teamwork / assertiveness
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},

Lack of resources, lack of knowledge, norms
{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
*/


/*
Lack of Communication 
{type: 'dirtyDozen', dirtyDozenId: 1, value: 1},

Distraction 
{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},

Lack of Resources 
{type: 'dirtyDozen', dirtyDozenId: 3, value: 1},

Stress 
{type: 'dirtyDozen', dirtyDozenId: 4, value: 1},

Complacency 
{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},

Lack of Teamwork 
{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},

Pressure 
{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},

Lack of Awareness 
{type: 'dirtyDozen', dirtyDozenId: 8, value: 1},

Lack of Knowledge 
{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},

Fatigue 
{type: 'dirtyDozen', dirtyDozenId: 10, value: 1},

Lack of Assertiveness 
{type: 'dirtyDozen', dirtyDozenId: 11, value: 1},

Norms 
{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},

*/

/*
{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
*/

let eventCardsData = {
	/* Day 1 */
	'day-1': [
		{
			id: 5,
			title: {
				en: 'The missing tool',
				de: 'Das fehlende Werkzeug',
				pt: 'A ferramenta em falta'
			},
			text: {
				en: 'After maintenance the aircraft is scheduled to fly right away to make a slot at a painting facility. A tool used on the aircraft can however not accounted for.',
				de: 'Nach der Wartung ist geplant, dass das Flugzeug sofort abfliegt, um einen Termin in einer Lackieranlage wahrzunehmen. Ein am Luftfahrzeug verwendetes Werkzeug ist jedoch nicht auffindbar. ',
				pt: 'Após a manutenção, a aeronave está programada para voar imediatamente e ocupar um horário numa oficina de pintura. No entanto, uma ferramenta utilizada na aeronave não foi localizada.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Ground the aircraft until the tool is recovered.',
						de: 'Das Luftfahrzeug muss am Boden bleiben, bis das Werkzeug geborgen ist.',
						pt: 'Mantem a aeronave em solo até que a ferramenta seja recuperada.'
					},
					consequences: {
						text: {
							en: 'Tool control is essential to prevent FOD.',
							de: 'Die Kontrolle des Werkzeugs ist wichtig, um FOD zu vermeiden.',
							pt: 'O controle das ferramentas é essencial para prevenir danos por objetos estranhos (FOD).'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'Let the aircraft do the ferry flight and use the down time during painting to search for the tool.',
						de: 'Sie lassen das Flugzeug den Überführungsflug machen und nutzen die Ausfallzeit während der Lackierung, um nach dem Werkzeug zu suchen.',
						pt: 'Deixa a aeronave fazer o voo de posição e aproveite o tempo disponivel durante a pintura para procurar a ferramenta.'
					},
					consequences: {
						text: {
							en: 'The risk of problems is no less for a ferry flight than for a flight with passengers.',
							de: 'Das Risiko von Problemen ist bei einem Überführungsflug nicht geringer als bei einem Flug mit Passagieren.',
							pt: 'O risco de problemas não é menor num voo de posição do que num voo com passageiros.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 2},
							{type: 'dirtyDozen', dirtyDozenId: 8, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},	
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'Release the aircraft for flight but inform management so they can decide further action.',
						de: 'Sie geben das Luftfahrzeug für den Flug frei, informieren aber das Management, damit es über das weitere Vorgehen entscheiden kann.',
						pt: 'Liberta a aeronave para voo, mas informa a gestão para que possam decidir as próximas ações.'
					},
					consequences: {
						text: {
							en: 'The pilots expect a released aircraft to be in fully serviceable condition.',
							de: 'Die Piloten erwarten, dass ein freigegebenes Flugzeug in einem voll funktionsfähigen Zustand ist.',
							pt: 'Os pilotos esperam que uma aeronave despachada esteja em perfeitas condições de funcionamento.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 2},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 6,
			title: {
				en: 'Poor repairs',
				de: 'Schlechte Reparaturen',
				pt: 'Reparações mal efetuadas'
			},
			text: {
				en: 'An aircraft is back at the workshop after a long dry-lease. You notice some repairs which looks substandard.',
				de: 'Ein Flugzeug ist nach einem langen Dry-Lease wieder in der Werkstatt. Sie bemerken einige Reparaturen, die mangelhaft aussehen.',
				pt: 'Uma aeronave retorna à oficina após um longo período de locação sem serviços. Você percebe que algumas reparações lhe parecem de qualidade inferior.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You check the records to see if all repairs are duly signed for.',
						de: 'Sie überprüfen die Unterlagen, um festzustellen, ob alle Reparaturen ordnungsgemäß abgezeichnet sind.',
						pt: 'Você verifica os registros para ver se todos os reparos foram devidamente assinados.'
					},
					consequences: {
						text: {
							en: 'Never assume anything. Even if the paperwork is fine the repair may still be bad.',
							de: 'Erwarten Sie niemals etwas. Selbst wenn die Papiere in Ordnung sind, kann die Reparatur trotzdem mangelhaft sein.',
							pt: 'Nunca presuma nada. Mesmo que a documentação esteja em ordem, o reparo ainda pode estar malfeito.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You report your findings to the manager',
						de: 'Sie melden Ihre Feststellungen an den Manager.',
						pt: 'Você reporta suas descobertas ao gerente.'
					},
					consequences: {
						text: {
							en: 'Reporting thru proper channels may help direct resources to addressing this issue.',
							de: 'Die Meldung über die richtigen Wege kann dazu beitragen, dass Ressourcen für die Behebung des Problems bereitgestellt werden.',
							pt: 'O reporte pelos canais adequados pode ajudar a direcionar recursos para a resolução desse problema.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do nothing as the aircraft has been accepted back after the lease.',
						de: 'Sie unternehmen nichts, da das Flugzeug nach Ablauf des Leasingvertrags zurückgenommen wurde.',
						pt: 'Você não precisa fazer nada, pois a aeronave foi devolvida após o término do contrato de leasing.'
					},
					consequences: {
						text: {
							en: 'Maybe something has been overlooked? Your input may be needed here.',
							de: 'Wurde vielleicht etwas übersehen? Hier könnte Ihr Beitrag gefragt sein.',
							pt: 'Talvez algo tenha sido esquecido? Sua opinião pode ser necessária aqui.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 7,
			title: {
				en: 'The modified tube',
				de: 'Das modifizierte Rohr',
				pt: 'O tubo modificado'
			},
			text: {
				en: 'A Service Bulletin to the hydraulic system requires installation of a modified tube. The delivered part does not fit quite well.',
				de: 'Ein Service Bulletin zum Hydrauliksystem erfordert den Einbau eines modifizierten Rohrs. Das gelieferte Teil passt nicht richtig.',
				pt: 'Um boletim de serviço para o sistema hidráulico exige a instalação de um tubo modificado. A peça fornecida não se encaixa perfeitamente.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You bend the tube so it will fit properly.',
						de: 'Sie biegen das Rohr, damit es richtig passt.',
						pt: 'Você dobra o tubo para que ele se encaixe corretamente.'
					},
					consequences: {
						text: {
							en: `Modifying components without proper maintenance date may negatively change the system's reliability.`,
							de: 'Die Änderung von Bauteilen ohne geeignete Wartungsanweisung kann sich negativ auf die Zuverlässigkeit des Systems auswirken.',
							pt: `Modificar componentes sem a devida manutenção pode afetar negativamente a confiabilidade do sistema.`
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You stop the installation and order a new pipe from the TC-holder.',
						de: 'Sie brechen die Installation ab und bestellen ein neues Rohr beim TC-Halter.',
						pt: 'Você interrompe a instalação e encomenda um novo tubo ao detentor de certificado técnico.'
					},
					consequences: {
						text: {
							en: 'Service or maintenance problems should always be reported. The TC-holder may be unaware about problems with his product.',
							de: 'Service- oder Wartungsprobleme sollten immer gemeldet werden. Der TC-Halter ist sich möglicherweise nicht über Probleme mit seinem Produkt im Klaren.',
							pt: 'Problemas de serviço ou manutenção devem sempre ser comunicados. O titular do certificado técnico pode não estar ciente de problemas com seu produto.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 3, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},

						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You force the pipe into position, since it is delivered with the approved SB kit.',
						de: 'Sie zwingen das Rohr in Position, da es mit dem zugelassenen SB-Kit geliefert wird.',
						pt: 'Você força o tubo para a posição correta, já que ele é entregue com o kit SB aprovado.'
					},
					consequences: {
						text: {
							en: 'Complacency may cause best maintenance practices to be forgotten so damage to the system occurs.',
							de: 'Selbstgefälligkeit kann dazu führen, dass bewährte Wartungspraktiken vergessen werden und es zu Schäden am System kommt.',
							pt: 'A complacência pode levar ao esquecimento das melhores práticas de manutenção, resultando em danos ao sistema.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},

						],
					},
				},
			]
		},
		{
			id: 8,
			title: {
				en: 'The skin repair',
				de: 'Die Hautreparatur',
				pt: 'A reparação do skin'
			},
			text: {
				en: 'You are performing a repair to the skin. The job description contains a rivet pattern which you cannot apply due to its interference with an existing repair.',
				de: 'Sie führen eine Reparatur an der Skin durch. Die Auftragsbeschreibung enthält ein Nietmuster, das Sie nicht anwenden können, weil es mit einer bestehenden Reparatur kollidiert.',
				pt: 'Você está a efetuar um reparação de estruturas. A descrição do trabalho contém um padrão de rebites que você não pode aplicar devido à interferência com um reparo já existente.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You tweak the pattern slightly, so it can be applied.',
						de: 'Sie ändern das Muster leicht ab, damit es angewendet werden kann.',
						pt: 'Você ajusta ligeiramente o padrão para que ele possa ser aplicado.'
					},
					consequences: {
						text: {
							en: `Modifying maintenance date may negatively change the system's reliability.`,
							de: 'Die Änderung der Instandhaltungsvorgaben kann sich negativ auf die Zuverlässigkeit des Systems auswirken.',
							pt: `Alterar a data de manutenção pode afetar negativamente a confiabilidade do sistema.`
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 8, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},

						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You stop the work and request a new repair procedure taking the existing repair into consideration',
						de: 'Sie stoppen die Arbeit und beantragen ein neues Reparaturverfahren, das die bestehende Reparatur berücksichtigt.',
						pt: 'Você interrompe o trabalho e solicita um novo procedimento de reparo, levando em consideração o reparo existente.'
					},
					consequences: {
						text: {
							en: 'Maintenance problems should always be reported. The TC-holder may be unaware about the actual condition of in-service aircrafts.',
							de: 'Wartungsprobleme sollten immer gemeldet werden. Der TC-Halter kennt möglicherweise nicht den tatsächlichen Zustand der in Betrieb befindlichen Flugzeuge.',
							pt: 'Problemas de manutenção devem sempre ser relatados. O detentor do Certificado de Tipo pode desconhecer as condições reais das aeronaves em serviço.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You perform the repair as best as possible and sign it of as "temporary repair performed".',
						de: 'Sie führen die Reparatur so gut wie möglich durch und vermerken "Vorläufige Reparatur durchgeführt".',
						pt: 'Você realiza o reparo da melhor maneira possível e assina como "reparo temporário realizado".'
					},
					consequences: {
						text: {
							en: 'The quality of the repair may not be adequate. All jobs should be done to approved standards.',
							de: 'Die Qualität der Reparatur ist möglicherweise nicht ausreichend. Alle Arbeiten sollten nach genehmigten Standards durchgeführt werden.',
							pt: 'A qualidade do reparo pode não ser adequada. Todos os trabalhos devem ser realizados de acordo com as normas aprovadas.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		}
	],
	/* Day 2 */
	'day-2': [
		{
			id: 10,
			title: {
				en: 'Aircraft limitations',
				de: 'Einschränkungen des Luftfahrzeugs',
				pt: 'Limitações da aeronave'
			},
			text: {
				en: 'You have followed the procedure of the Minimum Equipment List and deferred some navigational equipment. This however means that the aircraft is restricted to operating in certain weather conditions.',
				de: 'Sie haben das Verfahren der Minimum Equipment List (MEL) befolgt und ein Navigationsgerät zurückgestellt. Dies bedeutet jedoch, dass das Flugzeug nur bei bestimmten Wetterbedingungen eingesetzt werden kann.',
				pt: 'Você seguiu o procedimento da Lista de Equipamentos Mínimos (MEL) e diferiu alguns equipamentos de navegação. Isso significa, no entanto, que a aeronave está restrita a operar em determinadas condições meteorológicas.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You have done your job and can leave the rest to the pilot.',
						de: 'Sie haben Ihre Arbeit getan und können den Rest dem Piloten überlassen.',
						pt: 'Você cumpriu sua função e pode deixar o resto com o piloto.'
					},
					consequences: {
						text: {
							en: 'At the time the pilot discovers the write-up, it may be to late or costly to change aircraft although weather enroute is questionable. This may put operational pressure and stress on the pilot.',
							de: 'Zu dem Zeitpunkt, an dem der Pilot die Aufzeichnung entdeckt, kann es zu spät oder zu teuer sein, das Flugzeug zu wechseln, obwohl das Wetter auf der Strecke unsicher ist. Dies kann den Piloten unter Druck und Stress setzen.',
							pt: 'No momento em que o piloto descobre o relatório, pode ser tarde demais ou muito caro trocar de aeronave, mesmo que as condições meteorológicas na rota sejam incertas. Isso pode gerar pressão operacional e stress para o piloto.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You contact operations or the pilot to inform about the condition.',
						de: 'Sie setzen sich mit dem Flugbetrieb oder dem Piloten in Verbindung, um ihn über die Situation zu informieren.',
						pt: 'Você deve contatar a equipe de operações ou o piloto para informar sobre a situação.'
					},
					consequences: {
						text: {
							en: 'It is important that communication reaches all of the involved parties.',
							de: 'Es ist wichtig, dass die Kommunikation alle beteiligten Parteien erreicht.',
							pt: 'É importante que a comunicação chegue a todas as partes envolvidas.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You wait at the aircraft so you are available to give a briefing to the pilot when he arrives.',
						de: 'Sie warten am Flugzeug, damit Sie dem Piloten eine Einweisung geben können, wenn er eintrifft.',
						pt: 'Você fica aguardando junto à aeronave para estar disponível para dar instruções ao piloto quando ele chegar.'
					},
					consequences: {
						text: {
							en: 'At that time flight planning may be difficult to change. This may put operational pressure and stress on the pilot.',
							de: 'Zu diesem Zeitpunkt ist es möglicherweise schwierig, die Flugplanung zu ändern. Dies kann den Piloten unter Druck und Stress setzen.',
							pt: 'Nesse momento, o plano de voo pode ser difícil de alterar. Isso pode gerar pressão operacional e estresse para o piloto.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'cost', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 11,
			title: {
				en: 'A double shift',
				de: 'Eine Doppelschicht',
				pt: 'O turno duplo'
			},
			text: {
				en: 'You have been asked to work a double shift to ensure that an aircraft is ready for the morning rotation. The maintenance tasks are quite commonplace and not covered by the rules for RII / Independent inspections.',
				de: 'Sie wurden gebeten, eine Doppelschicht zu übernehmen, um sicherzustellen, dass ein Flugzeug für die morgendliche Rotation bereit ist. Die Wartungsarbeiten sind recht alltäglich und fallen nicht unter die Vorschriften für "Required Inspection Item" (RII) / unabhängige Inspektionen.',
				pt: 'Você foi solicitado a trabalhar num turno duplo para garantir que uma aeronave esteja pronta para a rotação da manhã. As tarefas de manutenção são bastante comuns e não estão cobertas pelas normas para inspeções RII/Independentes.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You accept, but ask the supervisor to ensure that a colleague is available in the early morning, to double check your work.',
						de: 'Sie akzeptieren, bitten aber den Vorgesetzten, dafür zu sorgen, dass ein Kollege am frühen Morgen zur Verfügung steht, um Ihre Arbeit unabhängig zu überprüfen.',
						pt: 'Você aceita, mas pede ao supervisor que garanta que um colega esteja disponível no início da manhã para verificar seu trabalho.'
					},
					consequences: {
						text: {
							en: 'Applying Error Capturing techniques is a good way of counteracting the negative effects of working long hours.',
							de: 'Die Anwendung von Fehlererfassungstechniken ist ein gutes Mittel, um den negativen Auswirkungen der langen Arbeitszeiten entgegenzuwirken.',
							pt: 'Aplicar técnicas de captura de erros é uma boa maneira de neutralizar os efeitos negativos de trabalhar muitas horas.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You refuse to do this work, because you think your chance of making a mistake is unacceptable large, if you work so many hours.',
						de: 'Sie weigern sich, diese Arbeit zu erledigen, weil Sie der Meinung sind, dass die Gefahr, einen Fehler zu machen, bei so vielen Arbeitsstunden unzumutbar groß ist.',
						pt: 'Você se recusa a fazer esse trabalho porque acha que a chance de cometer um erro é inaceitavelmente grande se trabalhar tantas horas.'
					},
					consequences: {
						text: {
							en: 'Postponing the work increase operational cost and may cause scheduling problems elsewhere in the organisation.',
							de: 'Die Verschiebung der Arbeit erhöht die Betriebskosten und kann an anderer Stelle im Unternehmen zu Problemen bei der Zeitplanung führen.',
							pt: 'Adiar o trabalho aumenta os custos operacionais e pode causar problemas de planejamento em outras áreas da organização.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds:[3, 9, 12]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do the job.',
						de: 'Sie machen die Arbeit.',
						pt: 'Você faz o trabalho.'
					},
					consequences: {
						text: {
							en: 'Ignoring the effect of working long hours, especially during WOCL (Window of Circadian Low), may increase the risk of making mistakes and affect your physical performance, decision making and level of attention.',
							de: 'Die Auswirkungen langer Arbeitszeiten, insbesondere während des WOCL (Window of Circadian Low), zu ignorieren, kann das Fehlerrisiko erhöhen und die körperliche Leistungsfähigkeit, das Entscheidungsvermögen und die Aufmerksamkeit beeinträchtigen.',
							pt: 'Ignorar os efeitos de longas jornadas de trabalho, especialmente durante o período de baixa atividade circadiana (WOCL), pode aumentar o risco de erros e afetar o desempenho físico, a tomada de decisões e o nível de atenção.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 10, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 12,
			title: {
				en: 'The missing supervisor',
				de: 'Der fehlende Vorgesetzte',
				pt: 'O supervisor em falta'
			},
			text: {
				en: `At the start of work, the supervisor doesn't show up. You get a phone call from the Reception relaying a message, that the supervisor is at the hospital undergoing emergency surgery.`,
				de: 'Zu Beginn der Arbeit erscheint der Vorgesetzte nicht. Sie erhalten einen Anruf von der Rezeption, die Ihnen mitteilt, dass der Vorgesetzte im Krankenhaus ist und notoperiert wird.',
				pt: `No início do expediente, o supervisor não aparece. Você recebe um telefonema da recepção informando que o supervisor está no hospital passando por uma cirurgia de emergência.`
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You and your colleagues take a seat in the break room waiting for somebody to come and act as manager.',
						de: 'Sie und Ihre Kollegen nehmen im Pausenraum Platz und warten darauf, dass jemand kommt und die Leitung übernimmt.',
						pt: 'Você e seus colegas sentam-se na sala de descanso aguardando que alguém venha assumir a função de gerente.'
					},
					consequences: {
						text: {
							en: 'Planned maintenance are not performed and operational problems and pressure increase. Lack of communication cause confusion and induces wrong decisions throughout the organisation.',
							de: 'Geplante Wartungsarbeiten werden nicht durchgeführt und die betrieblichen Probleme und der Druck nehmen zu. Mangelnde Kommunikation sorgt für Verwirrung und führt zu Fehlentscheidungen im gesamten Unternehmen.',
							pt: 'A manutenção planeada não é realizada, o que leva ao aumento dos problemas operacionais e da pressão. A falta de comunicação causa confusão e induz a decisões equivocadas em toda a organização.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},
							{type: 'cost', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You try to look up who is substitute but the organisational chart is outdated. You therefore assume the role as supervisor and starts delegating the work orders piled up on the office desk.',
						de: 'Sie versuchen nachzuschauen, wer die Vertretung ist, aber das Organigramm ist veraltet. Sie übernehmen also die Rolle des Vorgesetzten und beginnen, die Arbeitsaufträge, die sich auf dem Schreibtisch stapeln, zu delegieren.',
						pt: 'Você tenta descobrir quem é o substituto, mas o organograma está desatualizado. Portanto, você assume o papel de supervisor e começa a delegar as ordens de serviço acumuladas na mesa do escritório.'
					},
					consequences: {
						text: {
							en: 'Proactive and assertive action but lack of knowledge and lack of communication may cause you to focus on the wrong things. This may introduce operational problems.',
							de: 'Mangelndes Wissen und fehlende Kommunikation können dazu führen, dass Sie sich auf die falschen Dinge konzentrieren. Dies kann zu Problemen im Arbeitsablauf führen.',
							pt: 'A proatividade e a assertividade, aliadas à falta de conhecimento e de comunicação, podem levar ao foco em aspectos inadequados, o que pode gerar problemas operacionais.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]}, 
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You ask your colleagues if they know of any work that needs to be finished.',
						de: 'Sie fragen Ihre Kollegen, ob sie wissen, welche Arbeiten erledigt werden müssen.',
						pt: 'Você pergunta aos seus colegas se eles sabem de algum trabalho que precisa ser concluído.'
					},
					consequences: {
						text: {
							en: 'The situational awareness of both you and your colleagues may be inaccurate causing you to focus on the wrong things. This may introduce operational problems.',
							de: 'Das Situationsbewusstsein von Ihnen und Ihren Kollegen könnte ungenau sein, was dazu führt, dass Sie sich auf die falschen Dinge konzentrieren. Dies kann zu Problemen im Arbeitsablauf führen.',
							pt: 'A percepção situacional sua e de seus colegas pode ser imprecisa, fazendo com que vocês se concentrem em coisas erradas. Isso pode gerar problemas operacionais.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]}, 
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 13,
			title: {
				en: 'Maintenance Practices',
				de: 'Instandhaltungpraktiken',
				pt: 'Práticas de Manutenção'
			},
			text: {
				en: 'You are performing maintenance when an apprentice passing by, stops to let you know, that information given to him during recent class training about Best Maintenance Practices, could possibly apply to the job you are undertaking.',
				de: 'Sie führen Wartungsarbeiten durch, als ein Auszubildender vorbeikommt und Sie darauf hinweist, dass er während der letzten Schuleinheit über die empfohlenen Wartungspraktiken Informationen erhalten hat, möglicherweise auf die von Ihnen durchgeführte Arbeit zutreffen könnten.',
				pt: 'Você está realizando manutenção quando um aprendiz que passa por perto para para lhe avisar que as informações que recebeu durante o treino recente sobre as melhores práticas de manutenção podem ser aplicadas ao trabalho que você está executando.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: `You tell the apprentice to go away. You work by the Aircraft Maintenance Manual and it doesn't mention anything about changed procedures.`,
						de: 'Sie sagen dem Lehrling, er solle verschwinden. Sie arbeiten nach dem Flugzeug-Wartungshandbuch, und darin steht nichts über geänderte Verfahren.',
						pt: `Você manda o aprendiz embora. Você trabalha seguindo o Manual de Manutenção de Aeronaves e ele não menciona nada sobre mudanças nos procedimentos.`
					},
					consequences: {
						text: {
							en: 'Dismissing the apprentice may discourage future knowledge sharing, prevent a valuable learning experience and induce lack of assertiveness in the apprentice.',
							de: 'Wenn Sie den Auszubildenden wegschicken, kann dies die Weitergabe von Wissen behindern, eine wertvolle Lernerfahrung verhindern und zu mangelndem Selbstvertrauen bei dem Auszubildenden führen.',
							pt: 'Dispensar o aprendiz pode desencorajar a partilha de conhecimento no futuro, impedir uma experiência de aprendizagem valiosa e induzir a falta de assertividade no aprendiz.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 11, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You ask the apprentice to provide you with some material about this so you can study it at a later time.',
						de: 'Sie bitten den Auszubildenden, Ihnen einige Unterlagen zu diesem Thema zur Verfügung zu stellen, damit Sie sie zu einem späteren Zeitpunkt prüfen können.',
						pt: 'Você pede ao aprendiz que lhe forneça algum material sobre isso para que você possa estudá-lo posteriormente.'
					},
					consequences: {
						text: {
							en: 'Both you and the apprentice may forget do look more into this. Valuable information may be lost.',
							de: 'Möglicherweise vergessen sowohl Sie als auch der Auszubildende, sich intensiver damit zu befassen. Wertvolle Informationen können dadurch verloren gehen.',
							pt: 'Tanto você quanto o aprendiz podem se esquecer de investigar isso mais a fundo. Informações valiosas podem ser perdidas.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'This information is new to you and you go to the supervisor straight away, to suggest that a staff meeting is held to discuss how to deal with these new Best Maintenance Practices.',
						de: 'Sie gehen sofort zum Vorgesetzten und schlagen vor, eine Personalversammlung abzuhalten, um zu besprechen, wie man mit diesen neuen "Best Practices" in der Instandhaltung umgeht.',
						pt: 'Essa informação é nova para você e você vai direto ao supervisor para sugerir que uma reunião de equipe seja realizada para discutir como lidar com essas novas Boas Práticas de Manutenção.'
					},
					consequences: {
						text: {
							en: 'A proactive and immediate response. You are however getting distracted from your present task at the risk of making an error or omission later.',
							de: 'Sie werden jedoch von Ihrer aktuellen Aufgabe abgelenkt und riskieren, dass Ihnen später ein Fehler oder ein Versäumnis unterläuft.',
							pt: 'Uma resposta proativa e imediata. No entanto, você está se distraindo da sua tarefa atual, correndo o risco de cometer um erro ou omissão mais tarde.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		}
	],
	/* Day 3 */
	'day-3': [
		{
			id: 20,
			title: {
				en: 'The STC',
				de: 'Das STC',
				pt: 'O STC'
			},
			text: {
				en: 'You are working on a system which was previously modified by an STC. The STC is not available and you have to replace some worn bolts during the job.',
				de: 'Sie arbeiten an einem System, das zuvor von einem STC modifiziert wurde. Das STC ist nicht verfügbar und Sie müssen während der Arbeit einige abgenutzte Bolzen ersetzen.',
				pt: 'Você está trabalhando em um sistema que foi previamente modificado por um Certificado Suplementar de Tipo (STC). O STC não está disponível e você precisa substituir alguns parafusos desgastados durante o trabalho.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You identify the bolt type by examining the old ones.',
						de: 'Sie identifizieren den Schraubentyp, indem Sie die alten Schrauben untersuchen.',
						pt: 'Você identifica o tipo de parafuso examinando os antigos.'
					},
					consequences: {
						text: {
							en: 'This action have the potential for many types of errors - and maybe the installed bolt was actually the wrong type.',
							de: 'Bei dieser Aktion können viele Fehler auftreten - und möglicherweise war die installierte Schraube schon falsch.',
							pt: 'Essa ação pode levar a vários tipos de erros - e talvez o parafuso instalado fosse, na verdade, do tipo errado.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 8, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You stop work and request a copy of the STC',
						de: 'Sie stoppen die Arbeit und fordern eine Kopie des STC an.',
						pt: 'Interrompa o trabalho e solicite uma cópia do STC.'
					},
					consequences: {
						text: {
							en: 'It is essential to always use the proper maintenance data.',
							de: 'Es ist wichtig, dass Sie immer die richtigen Instandhaltungsunterlagen verwenden.',
							pt: 'É essencial utilizar sempre os dados de manutenção corretos.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You use a standard bolt and annotate the work card that this should be checked again when the STC is available.',
						de: 'Sie verwenden eine Standardschraube und vermerken auf der Arbeitskarte, dass diese erneut überprüft werden soll, sobald das STC verfügbar ist.',
						pt: 'Você usa um parafuso padrão e anota na ficha de trabalho que isso deve ser verificado novamente quando o STC estiver disponível.'
					},
					consequences: {
						text: {
							en: 'It may introduce a latent fault into the system if unapproved hardware is used.',
							de: 'Die Verwendung von nicht zugelassenen Bauteilen kann einen latenten Fehler in das System einbringen.',
							pt: 'O uso de hardware não homologado pode introduzir uma falha latente no sistema.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 21,
			title: {
				en: 'The quarantined grease',
				de: 'Das gesperrte Schmierfett',
				pt: 'o grease em quarentena'
			},
			text: {
				en: 'During a lubrication task you run out of grease. You know that similar grease is in quarantine due to a missing certificate.',
				de: 'Während einer Schmierungsaufgabe geht Ihnen das Fett aus. Sie wissen, dass ein ähnliches Schmierfett aufgrund eines fehlenden Zertifikats in Quarantäne ist.',
				pt: 'Durante uma tarefa de lubrificação, o grease acaba. Você sabe que um grease similar está em quarentena devido à falta de certificado.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Stop work until the grease is formally available.',
						de: 'Sie stoppen die Arbeit, bis das Fett offiziell verfügbar ist.',
						pt: 'Suspenda os trabalhos até que o grease esteja formalmente disponível.'
					},
					consequences: {
						text: {
							en: 'A proper response which may be challenged due to operational pressure.',
							de: 'Eine angemessene Reaktion, die aufgrund des betrieblichen Drucks in Frage gestellt werden kann.',
							pt: 'Uma resposta adequada que pode ser questionada devido à pressão operacional.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
			
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'Use the grease but annotate it in the records that unapproved consumables were used.',
						de: 'Verwenden Sie das Schmierfett, aber vermerken Sie in den Aufzeichnungen, dass nicht zugelassene Verbrauchsmaterialien verwendet wurden.',
						pt: 'Utilize o grease, mas anote nos registros que foram usados ​​consumíveis não aprovados.'
					},
					consequences: {
						text: {
							en: 'It may introduce a latent fault into the system if an unapproved consumable is used.',
							de: 'Die Verwendung eines nicht zugelassenen Verbrauchsmaterials kann einen Fehler verursachen.',
							pt: 'O uso de um consumível não aprovado pode introduzir uma falha latente no sistema.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'Borrow some grease from the company next door.',
						de: 'Leihen Sie sich etwas Schmierfett von der Firma nebenan.',
						pt: 'Pegue um pouco de grease emprestada da empresa vizinha.'
					},
					consequences: {
						text: {
							en: 'This may work if you remember that this grease also need receiving inspection and documentation.',
							de: 'Das kann funktionieren, wenn Sie daran denken, dass auch dieses Fett einer Eingangskontrolle und Dokumentation unterzogen werden muss.',
							pt: 'Isso pode funcionar se você se lembrar que esse grease também precisa passar por inspeção e documentação.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'risk', value: 2, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 22,
			title: {
				en: 'The open toolbox',
				de: 'Der offene Werkzeugkasten',
				pt: 'A caixa de ferramenta'
			},
			text: {
				en: 'You are called in, outside of business hours, to tow an aircraft out of the hangar. You notice an open toolbox in the vicinity of the aircraft.',
				de: 'Sie werden außerhalb der Geschäftszeiten gerufen, um ein Flugzeug aus dem Hangar zu schleppen. Sie bemerken einen offenen Werkzeugkasten in der Nähe des Flugzeugs.',
				pt: 'Você é chamado, fora do horário comercial, para rebocar uma aeronave para fora do hangar. Você percebe uma caixa de ferramentas aberta nas proximidades da aeronave.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'Check the toolbox to see if something is missing',
						de: 'Sie überprüfen die Werkzeugkiste, um zu sehen, ob etwas fehlt.',
						pt: 'Verifique a caixa de ferramentas para ver se falta alguma coisa.'
					},
					consequences: {
						text: {
							en: 'That is fine if you have an updated list of tools available.',
							de: 'Das ist in Ordnung, wenn Sie eine aktuelle Liste der Werkzeuge zur Verfügung haben.',
							pt: 'Isso não é problema, desde que você tenha uma lista atualizada de ferramentas disponíveis.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'Use the present padlock to lock the box',
						de: 'Verwenden Sie das vorhandene Vorhängeschloss, um den Kasten zu verschließen.',
						pt: 'Use o cadeado que está presente para trancar a caixa.'
					},
					consequences: {
						text: {
							en: 'It may already be to late for preventing tools to be unaccounted for.',
							de: 'Es fehlen möglicherweise bereits Werkzeuge.',
							pt: 'Pode já ser tarde demais para evitar que as ferramentas desapareçam.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 5, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'Call the owner of the toolbox, to verify that he has not been working on that aircraft.',
						de: 'Rufen Sie den Besitzer des Werkzeugkastens an, um sich zu vergewissern, dass er nicht an dem Flugzeug gearbeitet hat.',
						pt: 'Ligue para o dono da caixa de ferramentas para verificar se ele não esteve trabalhando naquela aeronave.'
					},
					consequences: {
						text: {
							en: 'This may not guarantee that others has not used this tool box.',
							de: 'Dies ist jedoch keine Garantie dafür, dass andere Personen den Werkzeugkasten nicht benutzt haben.',
							pt: 'Isso não garante que outras pessoas não tenham usado essa caixa de ferramentas.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 23,
			title: {
				en: 'Removing a component',
				de: 'Ausbauen einer Komponente',
				pt: 'Remoção de um componente'
			},
			text: {
				en: 'You are performing a task involving removing a component in order to clean it. Removal/installation is very time consuming and more experienced staff say they normally clean it without removing it.',
				de: 'Sie führen eine Aufgabe durch, bei der Sie ein Bauteil ausbauen, um es zu reinigen. Der Ausbau/Einbau ist sehr zeitaufwändig, und erfahrenere Mitarbeiter sagen, dass sie das Bauteil normalerweise reinigen, ohne es auszubauen.',
				pt: 'Você está realizando uma tarefa que envolve a remoção de um componente para limpá-lo. A remoção/instalação consome muito tempo e funcionários mais experientes dizem que normalmente limpam o componente sem removê-lo.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You adapt that practice as well.',
						de: 'Sie übernehmen diese Praxis ebenfalls.',
						pt: 'Você também adapta essa prática.'
					},
					consequences: {
						text: {
							en: 'If an undocumented procedure is in fact better, you should take steps to making it formal - and not use it until then.',
							de: 'Wenn ein nicht dokumentiertes Verfahren tatsächlich besser ist, sollten Sie Schritte unternehmen, um es offiziell zu machen - und es bis dahin nicht anwenden.',
							pt: 'Se um procedimento não documentado for de facto melhor, você deve tomar medidas para formalizá-lo — e não o utilize até lá.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 9, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You chose to follow the time consuming procedure from the manual anyway.',
						de: 'Sie haben sich trotzdem dafür entschieden, das zeitaufwändige Verfahren aus dem Handbuch anzuwenden.',
						pt: 'Você optou por seguir o procedimento demorado do manual mesmo assim.'
					},
					consequences: {
						text: {
							en: 'It is essential to follow maintenance data but also to report impractical procedures.',
							de: 'Es ist wichtig, Wartungsdaten zu befolgen, aber auch unpraktische Verfahren zu melden.',
							pt: 'É essencial acompanhar os dados de manutenção, mas também relatar procedimentos impraticáveis.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You stop work and request a No Technical Objection from the manufacturer, that cleaning can take place while installed.',
						de: 'Sie stellen die Arbeiten ein und beantragen beim Hersteller eine technische Unbedenklichkeitsbescheinigung (NTO), dass die Reinigung im eingebauten Zustand erfolgen kann.',
						pt: 'Você interrompe o trabalho e solicita ao fabricante uma Declaração de Não Objeção Técnica, permitindo que a limpeza seja realizada com o equipamento instalado.'
					},
					consequences: {
						text: {
							en: 'A safe approach which however may be challenged due to operational pressure.',
							de: 'Dieser Ansatz ist sicher, kann jedoch aufgrund des betrieblichen Zeitdrucks in Frage gestellt werden.',
							pt: 'Uma abordagem segura, que, no entanto, pode ser posta em causa devido à pressão operacional.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
			]
		}
	],
	/* Day 4 */
	'day-4': [
		{
			id: 25,
			title: {
				en: 'On the apron',
				de: 'Auf dem Vorfeld',
				pt: 'No stand exterior'
			},
			text: {
				en: 'You are performing line maintenance on the apron when the weather deteriorates and it becomes windy and starts to rain.',
				de: 'Sie führen gerade Line Maintenance Arbeiten auf dem Vorfeld durch, als sich das Wetter verschlechtert. Es wird windig und es beginnt zu regnen.',
				pt: 'Você está realizando manutenção na linha de stand exterior quando o tempo piora, começa a ventar e a chover.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You stop work until the aircraft can be towed into a hangar',
						de: 'Sie unterbrechen die Arbeit, bis das Flugzeug in einen Hangar geschleppt werden kann.',
						pt: 'Você interrompe o trabalho até que a aeronave possa ser rebocada para um hangar.'
					},
					consequences: {
						text: {
							en: 'It can be required to perform line maintenance in the hangar if the weather is bad.',
							de: 'Bei schlechtem Wetter kann es erforderlich sein, die Line Maintenance im Hangar durchzuführen.',
							pt: 'Pode ser necessário realizar manutenção nas linhas de transmissão dentro do hangar em caso de mau tempo.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds:[4, 7, 10]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You continue work despite. It is only line maintenance after all.',
						de: 'Sie arbeiten trotzdem weiter. Es handelt sich schließlich nur um Line Maintenance.',
						pt: 'Você continua trabalhando apesar de tudo. Afinal, é apenas manutenção de linha.'
					},
					consequences: {
						text: {
							en: 'Working in adverse conditions can introduce errors. Also protection of the aircraft must be taken into consideration.',
							de: 'Das Arbeiten unter widrigen Bedingungen kann zu Fehlern führen. Auch der Schutz des Flugzeugs muss beachtet werden.',
							pt: 'Trabalhar em condições adversas pode introduzir erros. Além disso, a proteção da aeronave deve ser levada em consideração.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'The aircraft is not scheduled for flights so you plan to finish the work tomorrow, when the weather hopefully is better.',
						de: 'Das Flugzeug ist nicht für Flüge vorgesehen, also planen Sie, die Arbeit morgen zu beenden, wenn das Wetter dann hoffentlich besser ist.',
						pt: 'Como a aeronave não tem voos programados, você planeja terminar o trabalho amanhã, quando o tempo, espera-se, estiver melhor.'
					},
					consequences: {
						text: {
							en: 'An option if task handover is documented. Operational demands can however change creating stress.',
							de: 'Eine Lösung, wenn die Aufgabenübergabe richtig dokumentiert wurde. Änderungen im Arbeitsablauf können jedoch Stress verursachen.',
							pt: 'Uma opção viável se a transferência de tarefas for documentada. No entanto, as demandas operacionais podem mudar, gerando stress.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 4, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
							{type: 'time', value: -1, conditionType: 'skill', conditionIds: ['troubleshooter']},
						],
					},
				},
			]
		},
		{
			id: 26,
			title: {
				en: 'Visitors',
				de: 'Besucher',
				pt: 'Visitantes'
			},
			text: {
				en: 'You and a small team are performing a difficult and extensive modification. Management keeps showing up with potential customers to show what you are doing.',
				de: 'Sie und ein kleines Team führen eine schwierige und umfangreiche Modifikation durch. Die Geschäftsleitung taucht immer wieder mit potenziellen Kunden auf, um Ihnen zu zeigen, was Sie gerade tun.',
				pt: 'Você e uma pequena equipe estão realizando uma modificação complexa e extensa. A gerência continua aparecendo com clientes em potencial para mostrar o que vocês estão fazendo.'
			},
			certifiedCrewOnly: true,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You insist that this stops, so you can work uninterrupted.',
						de: 'Sie bestehen darauf, dass dies aufhört, damit Sie ungestört arbeiten können.',
						pt: 'Você insiste que isso pare, para que possa trabalhar sem interrupções.'
					},
					consequences: {
						text: {
							en: 'Distractions should be avoided where possible but some may be required due to operational demands.',
							de: 'Ablenkungen sollten nach Möglichkeit vermieden werden, sind aber aufgrund der betrieblichen Erfordernisse unter Umständen unvermeidlich.',
							pt: 'As distrações devem ser evitadas sempre que possível, mas algumas podem ser necessárias devido às exigências operacionais.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You have a team meeting to discuss how you can perform a safe work under these circumstances',
						de: 'Sie halten eine Teamsitzung ab, um zu besprechen, wie Sie unter diesen Umständen sicher arbeiten können.',
						pt: 'Você tem uma reunião de equipe para discutir como realizar um trabalho seguro nessas circunstâncias.'
					},
					consequences: {
						text: {
							en: 'Discussing problems and taking challenges into consideration using Human Factor knowledge is an important part of daily work.',
							de: 'Das Besprechen von Problemen und das Berücksichtigen von Herausforderungen mit Hilfe von Kenntnissen über menschliche Faktoren ist ein wichtiger Teil der täglichen Arbeit.',
							pt: 'Discutir problemas e considerar desafios, utilizando conhecimentos de fatores humanos, é uma parte importante do trabalho diário.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 2, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [4, 7, 10]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You do nothing. If management thinks this is a good idea in order to get new customers, you must play along.',
						de: 'Sie tun nichts. Wenn die Geschäftsleitung dies für eine gute Idee hält, um neue Kunden zu gewinnen, müssen Sie mitspielen.',
						pt: 'Você não faz nada. Se a gerência acha que essa é uma boa ideia para conseguir novos clientes, você tem que entrar no jogo.'
					},
					consequences: {
						text: {
							en: 'Management and staff should work together to resolve safety challenges.',
							de: 'Management und Mitarbeiter sollten gemeinsam an der Lösung von Sicherheitsproblemen arbeiten.',
							pt: 'A gerência e os funcionários devem trabalhar juntos para resolver os desafios de segurança.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]}, 
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['teamplayer']},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['experienced']},
						],
					},
				},
			]
		},
		{
			id: 27,
			title: {
				en: 'A near-miss',
				de: 'Ein Beinahe-Unfall',
				pt: 'Um quase acidente'
			},
			text: {
				en: 'A serious near-miss has occurred. You think a safety report should be filed, but your colleagues are afraid it will make the team look bad, if brought to the attention of management.',
				de: 'Ein schwerer Beinahe-Unfall hat sich ereignet. Sie sind der Meinung, dass ein Sicherheitsbericht eingereicht werden sollte, aber Ihre Kollegen befürchten, dass das Team schlecht dastehen würde, wenn es der Geschäftsleitung zur Kenntnis gebracht wird.',
				pt: 'Ocorreu um incidente grave que quase resultou em acidente. Você acha que um relatório de segurança deve ser preenchido, mas seus colegas temem que isso prejudique a imagem da equipe, caso chegue ao conhecimento da gerência.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You report it anyway.',
						de: 'Sie melden es trotzdem.',
						pt: 'Você reporta mesmo assim.'
					},
					consequences: {
						text: {
							en: 'Reporting should be done with confidence in a Just Culture. It is important to know what is going on.',
							de: 'Die Meldung sollte in einer fairen Atmosphäre mit Vertrauen erfolgen. Es ist wichtig zu wissen, was vor sich geht.',
							pt: 'Numa cultura justa, o reporte deve ser feito com confiança. É importante saber o que está acontecendo.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'time', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You do not report it.',
						de: 'Sie melden es nicht.',
						pt: 'Você não reporta o evento.'
					},
					consequences: {
						text: {
							en: 'Failure to report near misses and latent conditions may cause management to be unaware of the need for action.',
							de: 'Wenn Sie Beinahe-Unfälle und latente Zustände nicht melden, kann dies dazu führen, dass die Geschäftsleitung nicht weiß, dass Handlungsbedarf besteht.',
							pt: 'A falta de reportes de quase acidentes e condições latentes pode fazer com que a gerência desconheça a necessidade de intervenção.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'You verbally tell the supervisor about it, but refuse to give any details.',
						de: 'Sie erzählen dem Vorgesetzten mündlich davon, weigern sich aber, Einzelheiten zu nennen.',
						pt: 'Você relata o ocorrido verbalmente ao supervisor, mas se recusa a dar detalhes.'
					},
					consequences: {
						text: {
							en: 'Using informal reporting procedures may leave decision makers out of the loop.',
							de: 'Die Verwendung formloser Meldeverfahren kann dazu führen, dass die verantwortlichen Entscheidungsträger nicht informiert werden.',
							pt: 'A utilização de procedimentos informais de comunicação pode deixar os decisores alheios ao processo.'
						},
						effects: [
							{type: 'time', value: 1},
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 12, value: 1},
							{type: 'cost', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'cost', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		},
		{
			id: 28,
			title: {
				en: 'Personal protection',
				de: 'Persönlicher Arbeitsschutz',
				pt: 'Proteção pessoal'
			},
			text: {
				en: 'You are new to the workforce and notice that there is a relaxed attitude towards the lack of availability of personal protective equipment.',
				de: 'Sie sind neu am Arbeitsplatz und stellen fest, dass die fehlende Verfügbarkeit von persönlicher Schutzausrüstung locker gesehen wird.',
				pt: 'Você é novo no mercado de trabalho e percebe que existe uma atitude negligente em relação à falta de disponibilidade de equipamentos de proteção individual.'
			},
			certifiedCrewOnly: false,
			options: [
				{
					id: 'a',
					title: {
						en: 'Option A',
						de: 'Option A',
						pt: 'Option A'
					},
					text: {
						en: 'You refuse to do any work requiring protective equipment, unless it is available to you.',
						de: 'Sie weigern sich, Arbeiten auszuführen, die eine Schutzausrüstung erfordern, wenn diese nicht zur Verfügung steht.',
						pt: 'Você se recusa a realizar qualquer trabalho que exija equipamento de proteção, a menos que este esteja disponível para você.'
					},
					consequences: {
						text: {
							en: 'Challenging Norms can be difficult and subject you to pressure.',
							de: 'Die Anfechtung von Standards kann schwierig sein und Sie unter Druck setzen.',
							pt: 'Questionar as normas pode ser difícil e sujeitá-lo(a) a pressão.'
						},
						effects: [
							{type: 'cost', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 7, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [1, 6, 11]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'b',
					title: {
						en: 'Option B',
						de: 'Option B',
						pt: 'Option B'
					},
					text: {
						en: 'You ask a colleague to do your tasks, if they involve need for protective equipment.',
						de: 'Sie bitten einen Kollegen, Ihre Aufgaben zu übernehmen, wenn diese mit der Notwendigkeit von Schutzausrüstung verbunden sind.',
						pt: 'Você pede a um colega para realizar suas tarefas, caso elas exijam o uso de equipamentos de proteção.'
					},
					consequences: {
						text: {
							en: 'The problem is not resolved but just passed on to someone less assertive than you.',
							de: 'Das Problem wird nicht gelöst, sondern nur an jemanden weitergegeben, der weniger durchsetzungsfähig ist als Sie.',
							pt: 'O problema não foi resolvido, apenas transferido para alguém menos assertivo do que você.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 6, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [3, 9, 12]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
				{
					id: 'c',
					title: {
						en: 'Option C',
						de: 'Option C',
						pt: 'Option C'
					},
					text: {
						en: 'While you are still new to the team, you follow the norm of not using protective equipment, with the intention of raising your voice at a later time.',
						de: 'Solange Sie noch neu im Team sind, folgen Sie der internen Norm, keine Schutzausrüstung zu benutzen, mit der Absicht, Ihre Stimme zu einem späteren Zeitpunkt zu erheben.',
						pt: 'Embora você ainda seja novo na equipe, segue a norma de não usar equipamentos de proteção, com a intenção de se manifestar posteriormente.'
					},
					consequences: {
						text: {
							en: 'Working in a group, you may experience a gradual shift in your own willingness to accept larger risks.',
							de: 'Wenn Sie in einer Gruppe arbeiten, kann es sein, dass sich Ihre eigene Bereitschaft, größere Risiken einzugehen, mit der Zeit verändert.',
							pt: 'Ao trabalhar em grupo, você pode experimentar uma mudança gradual na sua própria disposição para aceitar riscos maiores.'
						},
						effects: [
							{type: 'risk', value: 1},
							{type: 'dirtyDozen', dirtyDozenId: 11, value: 1},
							{type: 'risk', value: 1, conditionType: 'dirtyDozen', conditionIds: [2, 5, 8]},
							{type: 'risk', value: -1, conditionType: 'skill', conditionIds: ['assertive']},
						],
					},
				},
			]
		}
	]
};


export { eventCardsData };
